import { all, takeLatest } from 'redux-saga/effects';

import {
  getReportAttendancesAction,
  getReportBenefitLossAction,
  getReportExpensesAction,
  getReportInventoriesAction,
  getReportOrdersAction,
  getReportRevenuesAction,
} from '@/redux/actions';

import { getReportAttendancesSaga } from './get-report-attendances';
import { getReportBenefitLossSaga } from './get-report-benefit-loss';
import { getReportExpensesSaga } from './get-report-expenses';
import { getReportInventoriesSaga } from './get-report-inventories';
import { getReportOrdersSaga } from './get-report-orders';
import { getReportRevenuesSaga } from './get-report-revenues';

export default function* root(): Generator {
  yield all([
    takeLatest(getReportAttendancesAction.request.type, getReportAttendancesSaga),
    takeLatest(getReportBenefitLossAction.request.type, getReportBenefitLossSaga),
    takeLatest(getReportExpensesAction.request.type, getReportExpensesSaga),
    takeLatest(getReportInventoriesAction.request.type, getReportInventoriesSaga),
    takeLatest(getReportOrdersAction.request.type, getReportOrdersSaga),
    takeLatest(getReportRevenuesAction.request.type, getReportRevenuesSaga),
  ]);
}
